var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-list',[_c('ion-list-header',[_vm._v("Feed")]),_vm._l((_vm.feedItems),function(item,index){return [(item.itemType === 'message')?_c('FeedMessage',{key:index,attrs:{"message":item}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }